export { wgs2gcj, gcj2wgs } from './proj'

export { default as geom } from './geom'

import geom from './geom'

import { wgs2gcj, gcj2wgs } from './proj'

export const gcj2wgsBatch = (d) => d.map(i => {
  let c = gcj2wgs(i.lng, i.lat)
  return { lat: c[1], lng: c[0] }
})

export const wgs2gcjBatch = (d) => d.map(i => {
  let c = wgs2gcj(i.lng, i.lat)
  return { lat: c[1], lng: c[0] }
})

export const wgs2gcjForObject = (d) => {
  if (d.longitude && d.latitude) {
    let conv = wgs2gcj(d.longitude, d.latitude)
    d.longitude = conv[0]
    d.latitude = conv[1]
  }
}

export const isEqual = (a, b, isArray) => {
  let lat1, lat2, lng1, lng2;
  if (isArray) {
    lng1 = a[0];
    lat1 = a[1];
    lng2 = b[0];
    lat2 = b[1];
  } else {
    lng1 = a.longitude
    lat1 = a.latitude
    lng2 = b.longitude
    lat2 = b.latitude
  }

  return (
    lat1 && lat2 && lng1 && lng2 &&

    Math.abs(lat1 - lat2) < 1e-8 &&
    Math.abs(lng1 - lng2) < 1e-8
  )
}

export const speed = (a, b) => {
  let distance = geom.distance({ lat: a[1], lng: a[0] }, { lat: b[1], lng: b[0] })
  let time = Math.round((new Date(a[2]).getTime() - new Date(a[2]).getTime()) / 1000)
  if (isNaN(time) || time < 0.1) {
    return 100
  } else {
    return 3.6 * distance / time // m/s
  }
}

export const heading = (a, b) => {
  return geom.heading({ lat: a[1], lng: a[0] }, { lat: b[1], lng: b[0] })
}